import './css/main.css';


import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';



barba.init({
  debug: true,
  timeout: 7000,
  transitions: [
    {
      name: 'opacity-transition',
      leave(data) {
        return gsap.to(data.current.container, {
          opacity: 0
        });
      },
      // * MA added this beforeEntry bit
      beforeEnter: function beforeEnter(data) {},
      enter(data) {},
      after(data) {
        return gsap.from(data.next.container, {
          opacity: 0
        });
      },
      afterOnce(data) {},
      once(data) {}
    }
  ]
});

function scrollToTop() {
  // window.scrollTo({top: 0, behavior: 'smooth'});
  window.scrollTo({ top: 0 });
}

history.scrollRestoration = "manual";
let scrollPosY = [0];

function menuHighlight(data) {
  import(/* webpackChunkName: "menuHighlight" */ "./js/components/menuHighlight.js").then(module => {
    const highlightIt = module.default;
    highlightIt(data);
  });
}

function bgColour(data) {
  import(/* webpackChunkName: "bgColour" */ "./js/components/bgColour.js").then(module => {
    const colourIt = module.default;
    colourIt(data);
  });
}


function hamburgerToggle(preset) {
    import(/* webpackChunkName: "hamburgerToggle" */ "./js/components/hamburgerToggle.js").then(module => {
      const toggle = module.default;
      toggle(preset);
    });
  }

let hamburgerOuter = document.getElementById("hamburgerOuter");
hamburgerOuter.addEventListener("click", function() {hamburgerToggle()});


barba.hooks.once(data => {
  menuHighlight(data);
  bgColour(data);
});

barba.hooks.afterOnce(data => {
 
});

barba.hooks.before(data => {
  if(data.trigger !== "back") {
    scrollPosY.push(barba.history.current.scroll.y);
    // console.log(barba.history.current.scroll.y)
    // console.log(scrollPosY)
  }
  hamburgerToggle('c');
  
});

barba.hooks.enter(data => {
  
  
});

barba.hooks.beforeEnter(data => {
  // scrollToTop();
  bgColour(data);
  
});

barba.hooks.after(data => {
  // subMenuToggle('open');
  if(data.trigger !== "back") {
    window.scrollTo(0,0);
  } else {
    setTimeout(() => {window.scrollTo(0, scrollPosY.pop())}, 100);
    // console.log(scrollPosY)
  }
  menuHighlight(data);
});
